import { createElement, forwardRef } from 'react';
import { box } from '../patterns/box.mjs';
import { splitProps } from '../helpers.mjs';
import { styled } from './factory.mjs';

export const Box = /* @__PURE__ */ forwardRef(function Box(props, ref) {
  const [patternProps, restProps] = splitProps(props, box.propKeys)
  const styleProps = box.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})